<div class='container'>
  <div class='pt-4'>
    <mat-form-field>

      <mat-label>Filter</mat-label>
      <input matInput (keyup)='applyFilter($event)' placeholder='Filter' #input>

    </mat-form-field>


    <table class='table table-striped' id='userTable'>
      <thead>
      <tr>
        <th scope='col' id='uidHead' (click)='onSort($event)'>UID
          <i *ngIf='isSortedUID' class='fas fa-long-arrow-alt-up'></i>
          <i *ngIf='!isSortedUID' class='fas fa-long-arrow-alt-down'></i></th>
        <th scope='col' id='displayNameHead' (click)='onSort($event)'>Display Name
          <i *ngIf='isSortedDisplayName' class='fas fa-long-arrow-alt-up'></i>
          <i *ngIf='!isSortedDisplayName' class='fas fa-long-arrow-alt-down'></i></th>
        <th scope='col' id='emailHead' (click)='onSort($event)'>Email
          <i *ngIf='isSortedEmail' class='fas fa-long-arrow-alt-up'></i>
          <i *ngIf='!isSortedEmail' class='fas fa-long-arrow-alt-down'></i></th>

        <th scope='col' id='roleHead' (click)='onSort($event)'>Role
          <i *ngIf='isSortedRole' class='fas fa-long-arrow-alt-up'></i>
          <i *ngIf='!isSortedRole' class='fas fa-long-arrow-alt-down'></i>
        </th>

        <th scope='col' id='orgHead' (click)='onSort($event)'>Organization
          <i *ngIf='isSortedOrg' class='fas fa-long-arrow-alt-up'></i>
          <i *ngIf='!isSortedOrg' class='fas fa-long-arrow-alt-down'></i>
        </th>

        <th scope='col' id='lastLoggedHead' (click)='onSort($event)'>Last Logged In
          <i *ngIf='isSortedOrg' class='fas fa-long-arrow-alt-up'></i>
          <i *ngIf='!isSortedOrg' class='fas fa-long-arrow-alt-down'></i>
        </th>
        <th scope='col'></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor='let i of [].constructor(20)' [hidden]='!loading || userListFiltered'>
        <td>
          <ngx-skeleton-loader count='1' [theme]="{
          'width': '100%'
        }"></ngx-skeleton-loader>
        </td>
        <td>
          <ngx-skeleton-loader count='1' [theme]="{
          'width': '100%'
        }"></ngx-skeleton-loader>
        </td>
        <td>
          <ngx-skeleton-loader count='1' [theme]="{
          'width': '100%'
        }"></ngx-skeleton-loader>
        </td>
        <td>
          <ngx-skeleton-loader count='1' [theme]="{
          'width': '100%'
        }"></ngx-skeleton-loader>
        </td>
        <td>
          <ngx-skeleton-loader count='1' [theme]="{
          'width': '100%'
        }"></ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngFor='let user of userListFiltered'
          [ngClass]="{'to-hover': !isEditing}">
        <td>
          <div (click)='navigateToUser(user)'>
            {{user.uid}}
          </div>
        </td>
        <td>
          <div [hidden]='user.isEditing'>
            {{user.displayName}}
          </div>
          <input [id]='"displayInput"+user.uid' class='form-control' type='text' [hidden]='!user.isEditing' [value]='user.displayName||""'>
        </td>
        <td>
          {{user.email}}
        </td>
        <td>
          <div class='name-cell'>{{user.customClaims?.userRole}}</div>
          <div class='mat-select-cell'>

            <mat-select *ngIf='isEditing'
                        [placeholder]='user.customClaims?.userRole'
                        (valueChange)='handleOrgDataChange($event)'>
              <mat-option [value]='[user.uid, role, (user.customClaims?.orgData?.id || "0")]'
                          *ngFor='let role of roles'>{{ role }}</mat-option>
              <!-- note that it's orgData.id, because custom claims gets overwritten with org firestore data -->

            </mat-select>
          </div>
        </td>
        <td>
          <div class='name-cell'>{{user.customClaims?.orgData?.name}}</div>
          <div class='mat-select-cell'>

            <mat-select *ngIf='isEditing'
                        [placeholder]='user.customClaims?.orgData?.name'
                        (valueChange)='handleOrgDataChange($event)'>
              <mat-option [value]='[user.uid,(user.customClaims?.userRole||"user"), org.id]'
                          *ngFor='let org of orgsDataArray'>{{ org.name }}</mat-option>
            </mat-select>
          </div>

        <td>
          {{user.metadata?.lastSignInTime || "N/A"}}
        </td>
        <td>

          <button type='button' class='btn h-50 hover-button'
                  [ngClass]="{'btn-primary': !isEditing, 'btn-success':isEditing}"
                  (click)='!isEditing ? editUsers($event, user) : updateUserOrgData(user)'>{{isEditing ? 'Save' : 'Edit'}}
          </button>
        </td>
      </tr>
      </tbody>
    </table>

  </div>
</div>
